import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Paginator, decorators } from "@orange-marmalade/paginate-this";
import { shortDate } from "LIB/formatters/date";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import { DataTable } from "MODULES/shared/components";
import { DISCREPANCY_TYPES } from "MODULES/Receiving/constants";
import New from "./New";
import Controls from "./Controls";
import ResolvedBadge from "./ResolvedBadge";
import UnresolvedBadge from "./UnresolvedBadge";
import EditDiscrepancy from "./Edit/EditDiscrepancy";
import AttachmentTag from "./AttachmentTag";

class Discrepancies extends React.Component {
  constructor() {
    super();
    this.closeEditModal = this.closeEditModal.bind(this);
  }

  state = {
    editModalOpen: false
  };

  attachments = attachments =>
    attachments.map((attachment, index) => (
      <AttachmentTag attachment={attachment} index={index} />
    ));

  openEditModal = discrepancy =>
    this.setState({ discrepancy, editModalOpen: true });

  closeEditModal = () => this.setState({ editModalOpen: false });

  renderRow = discrepancy => (
    <tr
      key={discrepancy.id}
      className="clickable"
      onClick={() => this.openEditModal(discrepancy)}
    >
      <td />
      <td>{shortDate(discrepancy.created_at)}</td>
      <td>{discrepancy.created_by.full_name}</td>
      <td>{DISCREPANCY_TYPES[discrepancy.discrepancy_type].label}</td>
      {discrepancy.reason ? (
        <NoteTooltipTableCell
          className="text-center"
          note={discrepancy.reason}
        />
      ) : (
        <td />
      )}
      <td>{this.attachments(discrepancy.attachments)}</td>
      <td>{discrepancy.resolved ? <ResolvedBadge /> : <UnresolvedBadge />}</td>
      <td>{get(discrepancy, "resolved_by.full_name")}</td>
      {discrepancy.reason_for_resolution ? (
        <NoteTooltipTableCell
          className="text-center"
          note={discrepancy.reason_for_resolution}
        />
      ) : (
        <td />
      )}
      <td className="text-center">
        <Controls
          discrepancy={discrepancy}
          openEditModal={() => this.openEditModal(discrepancy)}
        />
      </td>
    </tr>
  );

  render() {
    const { results, isLoading } = this.props;
    const { editModalOpen, discrepancy } = this.state;
    return (
      <div>
        <h2 style={{ marginTop: 26 }}>
          Discrepancies
          <New />
        </h2>

        <DataTable.Mini loading={isLoading} numbered noMargin>
          <DataTable.Head>
            <th />
            <th>Created On</th>
            <th>Created By</th>
            <th>Discrepancy Type</th>
            <th className="text-center">Reason for Discrepancy</th>
            <th>Images</th>
            <th>Status</th>
            <th>Resolved By</th>
            <th className="text-center">Reason for Resolution</th>
            <th className="text-center" />
          </DataTable.Head>
          <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
        </DataTable.Mini>
        <EditDiscrepancy
          open={editModalOpen}
          close={this.closeEditModal}
          discrepancy={discrepancy}
        />
        <nav
          className="text-center margin-top-none"
          aria-label="Search results pages"
        >
          <Paginator listId="discrepancies" />
        </nav>
      </div>
    );
  }
}

Discrepancies.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      discrepancy_type: PropTypes.string.isRequired
    })
  ),
  isLoading: PropTypes.bool.isRequired
};

const ConnectedTable = decorators.tabulate(Discrepancies);

export default props => <ConnectedTable listId="discrepancies" {...props} />;



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/Discrepancies.jsx